import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
const ignorePath = ['/login', '/404', '/403', '/401']

Vue.use(VueRouter)

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  scrollBehavior: () => ({ y: 0 }),
  routes
})
/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach((to, from, next) => {
  const isLogin = localStorage.getItem('cbaas_userinfo_islogin')
  const menusObj = localStorage.getItem('cbaas_system_menus_auth') || '{}'
  const allFuncsObj = localStorage.getItem('cbaas_system_all_auth') || '{}'
  let menus = {}
  let allFuncs = {}
  try {
    menus = JSON.parse(menusObj)
    allFuncs = JSON.parse(allFuncsObj)
  } catch (e) {
    console.log(e)
  }
  if (isLogin === '1') {
    // 阻止登录后从首页回退到登录，正常退出登录除外
    if (from.path === '/home' && to.path === '/login' && !to.query.type) {
      next({ path: '/home' })
    }
    if (to.meta && to.meta.auth) {
      //不在权限管理集合中的授权，默认通过
      if (!allFuncs[to.meta.auth.code] || !!menus[to.meta.auth.code]) {
        next()
      } else {
        next({
          path: '/401'
        })
      }
    } else {
      next()
    }
  } else {
    if (ignorePath.includes(to.path)) {
      next()
    } else {
      next({ path: '/login' })
    }
  }
})

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

router.afterEach((to, from) => {})

export default router
